!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("react"), require("@tinacms/react-core")) : "function" == typeof define && define.amd ? define(["exports", "react", "@tinacms/react-core"], e) : e((t = t || self)["@tinacms/git-client"] = {}, t.react, t.reactCore);
}(this, function (t, o, i) {
  "use strict";

  var e = (n.prototype.onSubmit = function (t) {
    return this.commit(t);
  }, n.prototype.onChange = function (t) {
    return this.writeToDisk(t);
  }, n.prototype.onUploadMedia = function (t) {
    return this.writeMediaToDisk(t);
  }, n.prototype.onDelete = function (t) {
    return this.deleteFromDisk(t);
  }, n.prototype.isAuthenticated = function () {
    return !0;
  }, n.prototype.commit = function (t) {
    return fetch(this.baseUrl + "/commit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: JSON.stringify(t)
    });
  }, n.prototype.push = function () {
    return fetch(this.baseUrl + "/push", {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }).catch(function (t) {
      console.error(t);
    });
  }, n.prototype.writeToDisk = function (t) {
    return fetch(this.baseUrl + "/" + encodeURIComponent(t.fileRelativePath), {
      method: "PUT",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: JSON.stringify(t)
    }).catch(function (t) {
      console.error(t);
    });
  }, n.prototype.writeMediaToDisk = function (t) {
    var e = new FormData();
    return e.append("file", t.content), e.append("directory", t.directory), fetch(this.baseUrl + "/upload", {
      method: "POST",
      body: e
    }).catch(function (t) {
      console.error(t);
    });
  }, n.prototype.deleteFromDisk = function (t) {
    return fetch(this.baseUrl + "/" + encodeURIComponent(t.relPath), {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: JSON.stringify(t)
    }).catch(function (t) {
      console.error(t);
    });
  }, n.prototype.reset = function (t) {
    return fetch(this.baseUrl + "/reset", {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: JSON.stringify(t)
    });
  }, n.prototype.show = function (t) {
    return fetch(this.baseUrl + "/show/" + encodeURIComponent(t), {
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }).then(function (t) {
      return t.json();
    });
  }, n.prototype.branch = function (t) {
    return fetch(this.baseUrl + "/" + (t ? "branches/" + t : "branch"), {
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }).then(function (t) {
      return t.json();
    });
  }, n.prototype.branches = function () {
    return fetch(this.baseUrl + "/branches", {
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }).then(function (t) {
      return t.json();
    });
  }, n);

  function n(t) {
    this.baseUrl = t;
  }

  var c = (Object.defineProperty(r.prototype, "git", {
    get: function get() {
      return this.cms.api.git;
    },
    enumerable: !0,
    configurable: !0
  }), r);

  function r(t, e, n, r) {
    var o = this;
    this.cms = t, this.relativePath = e, this.format = n, this.parse = r, this.show = function () {
      return o.git.show(o.relativePath).then(function (t) {
        return o.parse(t.content);
      });
    }, this.commit = function () {
      return o.git.commit({
        files: [o.relativePath]
      }).then(function (t) {
        return o.cms.events.dispatch({
          type: "git:commit",
          response: t
        });
      });
    }, this.reset = function () {
      o.cms.api.git.reset({
        files: [o.relativePath]
      });
    }, this.write = function (t) {
      o.git.writeToDisk({
        fileRelativePath: o.relativePath,
        content: o.format(t)
      });
    };
  }

  function u(n, r) {
    var o,
        i,
        c,
        t,
        a = {
      label: 0,
      sent: function sent() {
        if (1 & c[0]) throw c[1];
        return c[1];
      },
      trys: [],
      ops: []
    };
    return t = {
      next: e(0),
      throw: e(1),
      return: e(2)
    }, "function" == typeof Symbol && (t[Symbol.iterator] = function () {
      return this;
    }), t;

    function e(e) {
      return function (t) {
        return function (e) {
          if (o) throw new TypeError("Generator is already executing.");

          for (; a;) {
            try {
              if (o = 1, i && (c = 2 & e[0] ? i.return : e[0] ? i.throw || ((c = i.return) && c.call(i), 0) : i.next) && !(c = c.call(i, e[1])).done) return c;

              switch (i = 0, c && (e = [2 & e[0], c.value]), e[0]) {
                case 0:
                case 1:
                  c = e;
                  break;

                case 4:
                  return a.label++, {
                    value: e[1],
                    done: !1
                  };

                case 5:
                  a.label++, i = e[1], e = [0];
                  continue;

                case 7:
                  e = a.ops.pop(), a.trys.pop();
                  continue;

                default:
                  if (!(c = 0 < (c = a.trys).length && c[c.length - 1]) && (6 === e[0] || 2 === e[0])) {
                    a = 0;
                    continue;
                  }

                  if (3 === e[0] && (!c || e[1] > c[0] && e[1] < c[3])) {
                    a.label = e[1];
                    break;
                  }

                  if (6 === e[0] && a.label < c[1]) {
                    a.label = c[1], c = e;
                    break;
                  }

                  if (c && a.label < c[2]) {
                    a.label = c[2], a.ops.push(e);
                    break;
                  }

                  c[2] && a.ops.pop(), a.trys.pop();
                  continue;
              }

              e = r.call(n, a);
            } catch (t) {
              e = [6, t], i = 0;
            } finally {
              o = c = 0;
            }
          }

          if (5 & e[0]) throw e[1];
          return {
            value: e[0] ? e[1] : void 0,
            done: !0
          };
        }([e, t]);
      };
    }
  }

  var a = (s.prototype.persist = function (s) {
    return function (i, c, a, s) {
      return new (a = a || Promise)(function (t, e) {
        function n(t) {
          try {
            o(s.next(t));
          } catch (t) {
            e(t);
          }
        }

        function r(t) {
          try {
            o(s.throw(t));
          } catch (t) {
            e(t);
          }
        }

        function o(e) {
          e.done ? t(e.value) : new a(function (t) {
            t(e.value);
          }).then(n, r);
        }

        o((s = s.apply(i, c || [])).next());
      });
    }(this, void 0, void 0, function () {
      var e, n, r, o, i, c, a;
      return u(this, function (t) {
        switch (t.label) {
          case 0:
            e = [], n = 0, r = s, t.label = 1;

          case 1:
            return n < r.length ? (o = r[n], i = o.file, c = o.directory, [4, this.client.writeMediaToDisk({
              directory: c,
              content: i
            })]) : [3, 5];

          case 2:
            return [4, t.sent().json()];

          case 3:
            a = t.sent().filename, e.push({
              directory: c,
              filename: a
            }), t.label = 4;

          case 4:
            return n++, [3, 1];

          case 5:
            return [2, e];
        }
      });
    });
  }, s);

  function s(t) {
    this.client = t, this.accept = "*";
  }

  t.GitClient = e, t.GitFile = c, t.GitMediaStore = a, t.useGitFile = function (t, e, n) {
    var r = i.useCMS();
    return o.useMemo(function () {
      return new c(r, t, e, n);
    }, [r, t, e, n]);
  }, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});